import { useSearchParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { catalogApi } from '@/lib/api';
import { ProductGrid } from '@/components/ProductGrid';

export function Search() {
  const [params] = useSearchParams();
  const q = params.get('q') ?? '';
  const list = useQuery({
    queryKey: ['catalog', 'search', q],
    queryFn: async () => (await catalogApi.list({ q, limit: 60 })).data,
    enabled: q.length > 0,
  });
  return (
    <div className="space-y-6">
      <h1 className="font-display text-2xl">Search results for "{q}"</h1>
      <ProductGrid
        products={list.data}
        loading={list.isLoading}
        emptyMessage={q ? 'No spells matched.' : 'Type something to search.'}
      />
    </div>
  );
}
